module.exports = __webpack_public_path__ + "a19184cd12d71fae2c2352f1cd8746af.svg";